<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >系统服务</el-breadcrumb-item>
          <el-breadcrumb-item >消息提醒</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <div class="table-content">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">消息列表</div>
            </div>
          </div>
          <div class="table-list">
            <el-table
              border
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              :data="tableData"
              v-loading="loading"
              >
              <el-table-column
                prop="time"
                label="时间">
                <template slot-scope="scope">
                    {{scope.row.time}}
                    <el-badge is-dot class="item" v-if="scope.row.isRead==false"></el-badge>
                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                label="内容">
                <template slot-scope="scope">
                  <el-popover
                    placement="right"
                    trigger="click"
                    >
                    <span style="color: #fff;">{{scope.row.content}}</span>
                    <el-button class="hander-read" slot="reference" @click="showNewsDetail(scope.row,scope.$index)">{{scope.row.content}}</el-button>
                  </el-popover>
                </template>
              </el-table-column>
              </el-table>
          </div>

        </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        loading:false,
        tableData:[],
        tableHeight:0,
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      getData(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/message/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.messages){
                // 获取设备数据
                this.tableData = obj.data.messages;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      showNewsDetail(row,index){
        if(row.isRead == false){
          this.readNews(row,index)
        }
      },
      readNews(row,index){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/message/read';
        const data = {
          "id":row.id
        };
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.tableData[index].isRead = true;
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-210 < 300 ? 300 : window.innerHeight-210;
        })
      },
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun);
      
      this.sizeFun()

      this.getData()
    },
    created() {
      
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun);
    }
  }

</script>

<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .table-content{
    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-right: 10px;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-out{
          width: 89px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
        }

        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }
      }
    }

    .table-list{

      .hander{
        cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }

      .hander-read{
        cursor: pointer;
        color: #fff;
        background-color: transparent;
        border: 0px;
      }


      .action-button{
        width: 89px;
        height: 31px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 16px;
        font-size: 14px;

        font-weight: 400;
        color: #00DEFF;
        // line-height: 26px;
      }

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/news.vue